import React, { Component } from 'react';
import Header from '../common/Header';
import Sidebar from '../common/Sidebar';
import MobileNotification from '../common/MobileNotification';
import Button from '../common/Button';
import Schedule from '../common/Schedule';
import InboxComponents from './InboxComponents';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import SortBy from '../Results/SortBy';
import PageLoader from '../common/PageLoader';
import { size } from 'lodash';
import { imageBasePath } from '../../constants/staticData';
import MobileHeaderSearch from '../common/MobileHeaderSearch';

export default class Results extends Component {
    constructor(props, context) {
        super(props, context);
        this.toggleNotification = this.toggleNotification.bind(this);
        this.state = {
            searchMobile: false,
            notificationVisible: false,
            showSidebar: false,
            isChatRoomsLoaded: props.commonReducer.isChatRoomsLoaded ? true : false,
            sortByText: 'Newest to Oldest'
        };
    }
    componentWillMount() {
        const authData = JSON.parse(localStorage.businessAuthData);
        if (!this.props.commonReducer.isChatRoomsLoaded) {
            this.props.actions.getAllChatRooms(authData.garageId);
        }
        // document.body.addEventListener('mousedown', this.bodyClick.bind(this));
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.commonReducer.isChatRoomsLoaded && !this.state.isChatRoomsLoaded) {
            this.setState({ isChatRoomsLoaded: true });
        }
    }
    toggleNotification(isVisible) {
        this.setState({ notificationVisible: isVisible });
    }
    hclickCallBack() {
        this.setState({ showSidebar: !this.state.showSidebar });
    }
    bodyClick(e) {
        if (e.target.closest('.sidebar') == null) {
            this.setState({ showSidebar: false });
        }
    }

    render() {
        return (
            <div>
                {/*Header*/}
                <Header
                    searchMobile={this.state.searchMobile}
                    hideOption={() => this.setState({ searchMobile: true })}
                    notificationCount={2}
                    commonReducer={this.props.commonReducer}
                    actions={this.props.actions}
                    profileName=""
                    notificationCallBack={this.toggleNotification}
                    authReducer={this.props.authReducer}
                    hCallback={() => {
                        this.hclickCallBack();
                    }}
                    router={this.props.router}
                />
                <MobileNotification
                    isVisible={this.state.notificationVisible}
                    backBtnCallBack={this.toggleNotification}
                />
                <div className="main-wrapper">
                    {/*Sidebar*/}
                    <Sidebar
                        showSidebar={this.state.showSidebar}
                        router={this.props.router}
                        actions={this.props.actions}
                        commonReducer={this.props.commonReducer}
                        authReducer={this.props.authReducer}
                    />
                    <div className="container-fluid main-container">
                        <div className="col-md-9 mpad0 padr30">
                            <div className="overview-heading">
                                <h5>
                                    Inbox
                                    {' '}
                                    {this.state.isChatRoomsLoaded
                                        ? `(${size(this.props.commonReducer.chatRooms)} Unread)`
                                        : ''}
                                </h5>
                                {this.state.isChatRoomsLoaded &&
                                    <div
                                        className={
                                            this.props.commonReducer.chatRooms.length > 0
                                                ? 'filter-section'
                                                : 'filter-section hide'
                                        }
                                    >
                                        <div className="sorting-list" onClick={this.props.mapVisible}>
                                            <DropdownButton
                                                bsSize="small"
                                                id="dropdown-size-small"
                                                noCaret
                                                onSelect={e => {
                                                    this.setState({ sortByText: e });
                                                }}
                                                open={this.state.sortBy}
                                                title={
                                                    <span className="holder">
                                                        <i
                                                            className={
                                                                this.state.sortByText
                                                                    ? 'mdi mdi-swap-vertical pull-left active'
                                                                    : 'mdi mdi-swap-vertical pull-left'
                                                            }
                                                        />
                                                        <label>Sort by</label>
                                                        <i
                                                            className={
                                                                this.state.sortBy
                                                                    ? 'mdi mdi-chevron-up pull-right'
                                                                    : 'mdi mdi-chevron-down pull-right'
                                                            }
                                                        />
                                                    </span>
                                                }
                                            >
                                                <MenuItem
                                                    eventKey="Newest to Oldest"
                                                    className={
                                                        this.state.sortByText == 'Newest to Oldest' ? 'active' : ''
                                                    }
                                                >
                                                    Date: Newest to Oldest
                                                    {this.state.sortByText == 'Newest to Oldest' &&
                                                        <i className="mdi mdi-check" />}
                                                </MenuItem>
                                                <MenuItem
                                                    eventKey="Oldest to Newest"
                                                    className={
                                                        this.state.sortByText == 'Oldest to Newest' ? 'active' : ''
                                                    }
                                                >
                                                    Date: Oldest to Newest
                                                    {this.state.sortByText == 'Oldest to Newest' &&
                                                        <i className="mdi mdi-check" />}
                                                </MenuItem>
                                            </DropdownButton>
                                        </div>
                                    </div>}
                            </div>
                            <div className="content-view">
                                {this.state.isChatRoomsLoaded
                                    ? this.props.commonReducer.chatRooms.length > 0
                                          ? <InboxComponents
                                                {...this.props}
                                                sortBy={this.state.sortByText === 'Oldest to Newest' ? 'old' : 'new'}
                                            />
                                          : <div className="empty-state-holder">
                                                <span className="empty-state-content">
                                                    <img src={`${imageBasePath}/messages_empty_large.png`} />
                                                    <span>Oops! Looks like you don’t have any messages yet. </span>
                                                </span>
                                            </div>
                                    : <PageLoader />}
                            </div>
                        </div>
                        <div className="col-md-3 mpad0 padLeft0">
                            <Schedule commonReducer={this.props.commonReducer} router={this.props.router} />
                        </div>
                    </div>
                </div>
                {this.state.searchMobile &&
                    <div>

                        <MobileHeaderSearch
                            mobile={true}
                            actions={this.props.actions}
                            commonReducer={this.props.commonReducer}
                            mobSearchClick={() => this.setState({ searchMobile: false })}
                        />
                    </div>}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Inbox/Inbox.jsx